import { clsx } from 'clsx';
import type { ReactNode } from 'react';

export interface EmptyStateProps {
  title: string;
  description?: string;
  action?: ReactNode;
  icon?: ReactNode;
  className?: string;
}

export function EmptyState({ title, description, action, icon, className }: EmptyStateProps) {
  return (
    <div
      className={clsx(
        'flex flex-col items-center justify-center text-center py-16 px-6 rounded-md border border-dashed border-hairline',
        className
      )}
    >
      {icon && <div className="mb-4 text-muted-slate">{icon}</div>}
      <h3 className="text-feature-heading font-display text-ink text-balance">{title}</h3>
      {description && <p className="mt-2 text-body text-muted-slate max-w-sm">{description}</p>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
